import React, { createContext, useState, useEffect } from 'react';
import { onAuthEvent, AUTH_EVENTS } from '../utils/userPreferencesCookie';

export const InfoButtonContext = createContext();

export const InfoButtonProvider = ({ children }) => {
  const [showInfoButtons, setShowInfoButtons] = useState(() => {
    // Récupérer l'état depuis le localStorage au chargement
    const savedState = localStorage.getItem('showInfoButtons');
    return savedState !== null ? JSON.parse(savedState) : true;
  });

  // Sauvegarder l'état dans le localStorage à chaque changement
  useEffect(() => {
    localStorage.setItem('showInfoButtons', JSON.stringify(showInfoButtons));
  }, [showInfoButtons]);

  // Écouter les événements d'authentification pour réinitialiser/restaurer l'état
  useEffect(() => {
    const handleSignedOut = () => {
      setShowInfoButtons(true); // Par défaut activé
    };
    const handleSignedIn = () => {
      const saved = localStorage.getItem('showInfoButtons');
      if (saved !== null) {
        setShowInfoButtons(JSON.parse(saved));
      }
    };
    const cleanupOut = onAuthEvent(AUTH_EVENTS.SIGNED_OUT, handleSignedOut);
    const cleanupIn = onAuthEvent(AUTH_EVENTS.SIGNED_IN, handleSignedIn);
    return () => { cleanupOut(); cleanupIn(); };
  }, []);

  const toggleInfoButtons = () => {
    setShowInfoButtons(prevState => !prevState);
  };

  return (
    <InfoButtonContext.Provider value={{ showInfoButtons, toggleInfoButtons }}>
      {children}
    </InfoButtonContext.Provider>
  );
};
